// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntitlementType } from './EntitlementType';
import {
  EntitlementTypeFromJSON,
  EntitlementTypeFromJSONTyped,
  EntitlementTypeToJSON,
  EntitlementTypeToJSONTyped,
} from './EntitlementType';
import type { EntitlementStatus } from './EntitlementStatus';
import {
  EntitlementStatusFromJSON,
  EntitlementStatusFromJSONTyped,
  EntitlementStatusToJSON,
  EntitlementStatusToJSONTyped,
} from './EntitlementStatus';

/**
 *
 * @export
 * @interface GetEntitlementResponse
 */
export interface GetEntitlementResponse {
  /**
   * id of the entitlement
   * @type {string}
   * @memberof GetEntitlementResponse
   */
  id: string;
  /**
   * amount of ACUs
   * @type {number}
   * @memberof GetEntitlementResponse
   */
  amount: number;
  /**
   * cost basis
   * @type {string}
   * @memberof GetEntitlementResponse
   */
  costBasis: string;
  /**
   *
   * @type {EntitlementStatus}
   * @memberof GetEntitlementResponse
   */
  status: EntitlementStatus;
  /**
   *
   * @type {EntitlementType}
   * @memberof GetEntitlementResponse
   */
  type: EntitlementType;
  /**
   * start timestamp, RFC3339
   * @type {Date}
   * @memberof GetEntitlementResponse
   */
  start: Date;
  /**
   * end timestamp, RFC3339
   * @type {Date}
   * @memberof GetEntitlementResponse
   */
  end: Date;
  /**
   * timestamp the entitlement was claimed, RFC3339 (absent if not yet claimed)
   * @type {Date}
   * @memberof GetEntitlementResponse
   */
  claimedAt?: Date;
  /**
   * ORB Credit Block ID
   * @type {string}
   * @memberof GetEntitlementResponse
   */
  orbCreditBlockID?: string;
  /**
   * Salesforce subscription ID
   * @type {string}
   * @memberof GetEntitlementResponse
   */
  salesforceSubID?: string;
  /**
   * ORB Credit Block ID for the rollover
   * @type {string}
   * @memberof GetEntitlementResponse
   */
  rollOverCreditBlockID?: string;
  /**
   * percentage of unused ACUs that roll over to the next period
   * @type {number}
   * @memberof GetEntitlementResponse
   */
  rolloverPercentage?: number;
  /**
   * provisioning ID
   * @type {string}
   * @memberof GetEntitlementResponse
   */
  provisioningID?: string;
}

/**
 * Check if a given object implements the GetEntitlementResponse interface.
 */
export function instanceOfGetEntitlementResponse(
  value: object,
): value is GetEntitlementResponse {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('amount' in value) || value['amount'] === undefined) return false;
  if (!('costBasis' in value) || value['costBasis'] === undefined) return false;
  if (!('status' in value) || value['status'] === undefined) return false;
  if (!('type' in value) || value['type'] === undefined) return false;
  if (!('start' in value) || value['start'] === undefined) return false;
  if (!('end' in value) || value['end'] === undefined) return false;
  return true;
}

export function GetEntitlementResponseFromJSON(
  json: any,
): GetEntitlementResponse {
  return GetEntitlementResponseFromJSONTyped(json, false);
}

export function GetEntitlementResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GetEntitlementResponse {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    amount: json['amount'],
    costBasis: json['costBasis'],
    status: EntitlementStatusFromJSON(json['status']),
    type: EntitlementTypeFromJSON(json['type']),
    start: new Date(json['start']),
    end: new Date(json['end']),
    claimedAt:
      json['claimedAt'] == null ? undefined : new Date(json['claimedAt']),
    orbCreditBlockID:
      json['orbCreditBlockID'] == null ? undefined : json['orbCreditBlockID'],
    salesforceSubID:
      json['salesforceSubID'] == null ? undefined : json['salesforceSubID'],
    rollOverCreditBlockID:
      json['rollOverCreditBlockID'] == null
        ? undefined
        : json['rollOverCreditBlockID'],
    rolloverPercentage:
      json['rolloverPercentage'] == null
        ? undefined
        : json['rolloverPercentage'],
    provisioningID:
      json['provisioningID'] == null ? undefined : json['provisioningID'],
  };
}

export function GetEntitlementResponseToJSON(
  json: any,
): GetEntitlementResponse {
  return GetEntitlementResponseToJSONTyped(json, false);
}

export function GetEntitlementResponseToJSONTyped(
  value?: GetEntitlementResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    amount: value['amount'],
    costBasis: value['costBasis'],
    status: EntitlementStatusToJSON(value['status']),
    type: EntitlementTypeToJSON(value['type']),
    start: value['start'].toISOString(),
    end: value['end'].toISOString(),
    claimedAt:
      value['claimedAt'] == null ? undefined : value['claimedAt'].toISOString(),
    orbCreditBlockID: value['orbCreditBlockID'],
    salesforceSubID: value['salesforceSubID'],
    rollOverCreditBlockID: value['rollOverCreditBlockID'],
    rolloverPercentage: value['rolloverPercentage'],
    provisioningID: value['provisioningID'],
  };
}
